import { isReactComponent } from "../../_utils/is-react-component.func";
import { IRootieComponent, ValidComponent } from '@components-common/types';
import { isUndefined } from "ramda-adjunct";
import { T, cond } from "ramda";
import { isRootieComponent } from "@components-common/utils";
import { isJSXElement } from "../../_utils/is-JSX-element.func";
import { EmptyComponent } from "../defaults";

export type EnsureComponentProps<TProps extends {}> = {
  value?: ValidComponent<TProps>;
  defValue?: ValidComponent<TProps>;
}

const logWrapper = (msg:string, value:any, props?:any) => { console.log(msg,value, props); return value; }

export const EnsureComponent = <TProps extends {}>({value,defValue=EmptyComponent, props}:any) => {
  console.log("EnsureComponent:WRAPPER",value,props,defValue);
  const result = cond([
  [isUndefined, () => logWrapper("undefined",defValue!)],
  [isReactComponent, (value:any) => logWrapper("react-component",props ? value!(props) : value!())],
  [isJSXElement, (value:any) => logWrapper("jsx-component",value!())],
  [isRootieComponent, (value:IRootieComponent) => {console.log("rootie-component");const {Component, props} = value; return <Component {...props} />;}],

  [T, () => () => logWrapper("default-component",defValue!())]
])(value) as any;

return result;
}
